/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActivityEvent } from './ActivityEvent';
import {
    ActivityEventFromJSON,
    ActivityEventFromJSONTyped,
    ActivityEventToJSON,
    ActivityEventToJSONTyped,
} from './ActivityEvent';

/**
 * User notifications response with unread count
 * @export
 * @interface NotificationsResponse
 */
export interface NotificationsResponse {
    /**
     * 
     * @type {Array<ActivityEvent>}
     * @memberof NotificationsResponse
     */
    events: Array<ActivityEvent>;
    /**
     * Number of unread notifications
     * @type {number}
     * @memberof NotificationsResponse
     */
    unreadCount: number;
    /**
     * User's cursor (last seen event ID)
     * @type {number}
     * @memberof NotificationsResponse
     */
    lastSeenEventId: number;
}

/**
 * Check if a given object implements the NotificationsResponse interface.
 */
export function instanceOfNotificationsResponse(value: object): value is NotificationsResponse {
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('unreadCount' in value) || value['unreadCount'] === undefined) return false;
    if (!('lastSeenEventId' in value) || value['lastSeenEventId'] === undefined) return false;
    return true;
}

export function NotificationsResponseFromJSON(json: any): NotificationsResponse {
    return NotificationsResponseFromJSONTyped(json, false);
}

export function NotificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(ActivityEventFromJSON)),
        'unreadCount': json['unreadCount'],
        'lastSeenEventId': json['lastSeenEventId'],
    };
}

export function NotificationsResponseToJSON(json: any): NotificationsResponse {
    return NotificationsResponseToJSONTyped(json, false);
}

export function NotificationsResponseToJSONTyped(value?: NotificationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'events': ((value['events'] as Array<any>).map(ActivityEventToJSON)),
        'unreadCount': value['unreadCount'],
        'lastSeenEventId': value['lastSeenEventId'],
    };
}

